export type ValidationTranslation = {
  general: {
    required: string;
    maxLength: string;
  };
  phoneNumber: { format: string };
  url: { format: string };
};
export const validationTranslation: ValidationTranslation = {
  general: {
    required: 'To pole jest wymagane',
    maxLength: 'Maksymalna długość to {{max}} znaków',
  },
  phoneNumber: {
    format: 'Numer telefonu musi mieć od 9 do 15 cyfr',
  },
  url: {
    format: 'Link powinien zaczynać się od https://',
  },
};
